import "./image.css"
function Image(props){
    return(
        <div className={props.class}>
        
        </div>
    )
}
export default Image;